import { render } from "./productRepository.vue?vue&type=template&id=da96d84a"
import script from "./productRepository.vue?vue&type=script&lang=js"
export * from "./productRepository.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/repository/components/productRepository.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da96d84a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da96d84a', __exports__)) {
    api.reload('da96d84a', __exports__)
  }
  
  module.hot.accept("./productRepository.vue?vue&type=template&id=da96d84a", () => {
    api.rerender('da96d84a', render)
  })

}


export default __exports__